import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const MemoryChampion = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >

        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">

          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">

            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              How to Become a Memory Champion
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              The Memory Champion's Secret Isn't What You Think
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left Column */}
              <div className="max-w-2xl">

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  A few years ago, I gave a talk at the Latitude Music Festival in England.
                  I'd spent days preparing it. There were facts about drugs, neurotransmitters,
                  brain regions, and memory. Dopamine. Serotonin. The frontal lobes. The
                  hippocampus. Forty-five minutes of carefully organised neuroscience.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Afterwards, an award-winning memory champion named Richard Bowdler took the
                  stage. "I am going to give Dr. Owen's talk again," he announced. I settled
                  back, expecting disaster.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Instead, over the next few minutes, Richard calmly reproduced the entire
                  structure of my lecture, recalling the main points in exactly the right order.
                  Not word for word, but close enough to leave me speechless. I was the
                  neuroscientist. He had heard the talk once. Yet somehow, he remembered it
                  better than I did.
                </p>

              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/memory_champion.png"
                  alt="Memory Champion"
                  className="w-full max-w-[700px]"
                />
              </div>

            </div>

            {/* Full Width Text */}
            <div className="mt-2">
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                How? The obvious answer is that memory champions are simply born with
                extraordinary memories. But that's not what the science suggests. In fact,
                many memory champions begin with perfectly ordinary memories.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                What sets them apart is not necessarily the size of their memory, but how they
                use it. They have learned to exploit some of the most powerful features of
                working memory — the executive function that allows us to hold, manipulate,
                organise, and prioritise information in real time.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                This turns out to be one of the great surprises of cognitive neuroscience.
                Memory isn't simply about storage. It's about organisation. The world's best
                memorizers don't typically possess photographic memories or mysterious mental
                powers.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Instead, they use strategies that transform difficult information into
                something the brain finds easier to manage. They create mental structures,
                vivid associations, and imaginative shortcuts that allow them to achieve feats
                that seem almost magical.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                And the same principles can help all of us. Whether you're trying to remember
                names, master a presentation, learn a new language, study for an exam, or
                simply keep track of an increasingly complicated life, the neuroscience behind
                memory champions reveals something profound about how the human brain works.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover how working memory really
                operates, why some people appear to possess almost supernatural powers of
                recall, what neuroscience has revealed about the hidden architecture of
                memory, and why the secret to remembering more may have less to do with
                memory itself than with how you organise what enters your mind in the first
                place.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Because memory champions don't just remember better. They think differently
                about remembering.
              </p>

              {/* Creyos Test Button */}
                <div className="mt-12 text-center">
                  <a
                    href="https://habstudy.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                  >
                    IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE,
                    CLICK HERE
                  </a>
                </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MemoryChampion;